const WORKER = 'terminy.krynica-serwis.workers.dev';
const URL = `https://${WORKER}/`;

export async function getGoogleSheets(id) {
	try {
		const apartmentName = encodeURIComponent(id);
		const res = await fetch(`${URL}?apartmentName=${apartmentName}`);

		const apiData = await res.json();
		const { status, message, data } = apiData;
		if (status === 'error') throw new Error(message);
		return data;
	} catch (err) {
		console.error('googleSheetsApi: ', err);
	}
}
